import axiosClient from "../../system/helpers/axiosConfig";

export const getDataWithoutParams = (api) => {
  return axiosClient.get(api).then((r) => r.data);
};
